import { TInfrastructureItem } from '../../../types/map';

export const getCurrentRouteItem = (item: TInfrastructureItem | null, isObjectPoint: boolean) => {
  if (isObjectPoint) {
    return null;
  }

  return item;
};
